/**
 * Adds an index to the match array of a link.
 *
 * @param {Link} link
 * @param {number} index
 */
export function addMatch(link, index) {
    if (!link.match.includes(index)) {
        link.match.push(index);
    }
    return link;
}
//# sourceMappingURL=addMatch.js.map